import React, { useEffect } from "react";
import { CustomModal, CustomInput, CustomTextArea } from "#components";

const AddEditProductModal = ({
  open,
  onClose,
  handleSubmit,
  isLoadingAddProduct,
  isLoadingEditProduct,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  numberOnly,
  setOpenContainerUnitModal,
  setOpenContainerModal,
  refetchTypes,
  refetchUnits,
  isContainerTypesLoading,
  isContainerUnitsLoading,
  containerUnits,
  containerTypes,
  rateUnits,
  setOpenRateUnitModal,
  isRateUnitsLoading,
}) => {
  //Load API data into dropdown lists
  //When Add/Edit modal opens, refetch and reset selections
  useEffect(() => {
    if (open.add || open.edit) {
      refetchUnits();
      refetchTypes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);



  return (
    <CustomModal
      open={open.add || open.edit}
      title={open.add ? "Add New Product" : "Edit Product"}
      actionButtonTitle="Submit"
      onClose={() => onClose(open.add ? "add" : "edit")}
      onSubmit={handleSubmit}
      loading={isLoadingAddProduct || isLoadingEditProduct}
    >
      <div className="common-modal-form">
        <div className="row gy-4">
          {/* Product Name */}
          <div className="col-lg-6">
            <CustomInput
              label="Product Name"
              type="text"
              name="productName"
              placeholder="Enter your product name"
              value={values?.productName}
              error={errors?.productName}
              touched={touched?.productName}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>

          {/* Rate */}
          {/* Rate + Unit */}
          <div className="col-lg-6">
            <div className="common-modal-field">
              <label>Rate</label>

              <div style={{ display: "flex", alignItems: "center" }}>
                {/* Rate Input */}
                <input
                  type="text"
                  name="rate"
                  value={values.rate}
                  onChange={handleChange}
                  onKeyPress={numberOnly}
                  onBlur={handleBlur}
                  placeholder="Enter rate"
                  className="form-control"
                  style={{
                    width: "100%",
                    borderRadius: "12px 0px 0px 12px",
                  }}
                />

                {/* Rate Unit Dropdown + Add Button */}
                <div className="d-flex align-items-center gap-2">
                  <select
                    name="rateUnit"
                    value={values.rateUnit || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="form-select"
                    disabled={isRateUnitsLoading}
                    style={{
                      flex: 1,
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                      borderLeft: "none",
                      width: "100px",
                      minWidth: "150px",
                      maxWidth: "220px",
                      position: "relative",
                      zIndex: 9999,
                    }}
                  >
                    <option value="" disabled hidden>
                      Select unit
                    </option>

                    {isRateUnitsLoading ? (
                      <option>Loading...</option>
                    ) : !rateUnits || rateUnits.length === 0 ? (
                      <option value="" disabled>
                        No units available
                      </option>
                    ) : (
                      rateUnits.map((unit, index) => (
                        <option key={index} value={unit}>
                          {unit}
                        </option>
                      ))
                    )}
                  </select>

                  <button
                    type="button"
                    className="primary-btn"
                    onClick={() => setOpenRateUnitModal(true)}
                  >
                    Add Unit
                  </button>
                </div>
              </div>

              {/* Validation Errors */}
              {touched.rate && errors.rate && (
                <p style={{ color: "red", marginTop: "4px", marginBottom: 0 }}>
                  {errors.rate}
                </p>
              )}

              {touched.rateUnit && errors.rateUnit && (
                <p style={{ color: "red", marginTop: "4px", marginBottom: 0 }}>
                  {errors.rateUnit}
                </p>
              )}
            </div>
          </div>


          {/* Container Size + Unit */}
          <div className="col-lg-6">
            <div className="common-modal-field">
              <label>Container Size</label>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* Size Input */}
                <input
                  type="text"
                  name="containerSize"
                  value={values.containerSize}
                  onChange={handleChange}
                  onKeyPress={numberOnly}
                  onBlur={handleBlur}
                  placeholder="10.5"
                  className="form-control"
                  style={{
                    width: "100%",
                    borderRadius: "12px 0px 0px 12px",
                  }}
                />

                {/* Unit Dropdown + Add Button */}
                <div className="d-flex align-items-center gap-2">
                  <select
                    name="containerUnit"
                    value={values.containerUnit || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="form-select"
                    disabled={isContainerUnitsLoading}
                    style={{
                      flex: 1,
                      borderRadius: "0px 12px 12px 0px",
                      borderLeft: "none",
                      width: "100px",
                      minWidth: "150px",
                      maxWidth: "220px",
                      position: "relative",
                      zIndex: 9999,
                    }}
                  >
                    <option value="" disabled hidden>
                      Select unit
                    </option>

                    {isContainerUnitsLoading ? (
                      <option>Loading...</option>
                    ) : !containerUnits || containerUnits.length === 0 ? (
                      <option value="" disabled>
                        No units available
                      </option>
                    ) : (
                      containerUnits.map((unit, index) => (
                        <option key={index} value={unit}>
                          {unit}
                        </option>
                      ))
                    )}
                  </select>

                  <button
                    type="button"
                    className="primary-btn"
                    onClick={() => {
                      // onClose(open.add ? "add" : "edit");
                      setOpenContainerUnitModal(true);
                    }}
                  >
                    Add Unit
                  </button>
                </div>
              </div>

              {/*Validation error for container size */}
              {touched.containerSize && errors.containerSize && (
                <p style={{ color: "red", marginTop: "4px", marginBottom: 0 }}>
                  {errors.containerSize}
                </p>
              )}

              {/* Existing unit error (no change) */}
              {touched.containerUnit && errors.containerUnit && (
                <p style={{ color: "red", marginTop: "4px", marginBottom: 0 }}>
                  {errors.containerUnit}
                </p>
              )}
            </div>
          </div>

          {/* Container Type */}
          <div className="col-lg-6">
            <div className="common-modal-field">
              <label>Container Type</label>
              <div className="d-flex align-items-center gap-2">
                <select
                  name="containerType"
                  value={values.containerType || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-select"
                  style={{ flex: 1 }}
                >
                  <option value="" disabled hidden>
                    Select container type
                  </option>
                  {isContainerTypesLoading ? (
                    <option>Loading...</option>
                  ) : containerTypes.length > 0 ? (
                    containerTypes.map((type, index) => (
                      <option key={index} value={type}>
                        {type}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No container types available
                    </option>
                  )}
                </select>

                <button
                  type="button"
                  className="primary-btn"
                  onClick={() => {
                    // onClose(open.add ? "add" : "edit");
                    setOpenContainerModal(true);
                  }}
                >
                  Add Container Type
                </button>
              </div>
              {touched.containerType && errors.containerType && (
                <p style={{ color: "red", marginBottom: 0 }}>
                  {errors.containerType}
                </p>
              )}
            </div>
          </div>

          {/* Note */}
          <div className="mt-3">
            <CustomTextArea
              label="Note"
              placeholder="Enter note here"
              name="note"
              value={values.note}
              onChange={handleChange}
              touched={touched.note}
              error={errors?.note}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default AddEditProductModal;
